import { CustomStudentReportInfo } from './reducer';

export enum TypeKeys {
    SET_INITIAL_DATA = 'studentReport/SET_INITIAL_DATA',
    STUDENT_REPORT_INFO_LOADED = 'studentReport/STUDENT_REPORT_INFO_LOADED',
    TOGGLE_ADMIN_VIEW_REPORT_AS_STUDENT = 'studentReport/TOGGLE_ADMIN_VIEW_REPORT_AS_STUDENT',
    PRINT_STUDENT_REPORT = 'studentReport/PRINT_STUDENT_REPORT',
    STUDENT_REPORT_UPDATE = 'studentReport/STUDENT_REPORT_UPDATE',
    REMOVE_SUBMISSION = 'studentReport/REMOVE_SUBMISSION',
    TOGGLE_ADMIN_VIEW_RUBRIC_MARKS = 'studentReport/TOGGLE_ADMIN_VIEW_RUBRIC_MARKS',
    REQUEST_PRINT_CORRECTION = 'studentReport/REQUEST_CORRECTION'
}

export interface LoadInitialData {
    type: TypeKeys.SET_INITIAL_DATA;
    featureId: string;
}

export interface StudentReportInfoLoaded {
    type: TypeKeys.STUDENT_REPORT_INFO_LOADED;
    featureId: string;
    studentReportInfo: CustomStudentReportInfo;
}

export interface ToggleAdminViewReportAsStudent {
    type: TypeKeys.TOGGLE_ADMIN_VIEW_REPORT_AS_STUDENT;
    featureId: string;
}

export interface ToggleAdminViewRubricMarksAction {
    type: TypeKeys.TOGGLE_ADMIN_VIEW_RUBRIC_MARKS;
    featureId: string;
}

export interface PrintStudentReport {
    type: TypeKeys.PRINT_STUDENT_REPORT;
    featureId: string;
}

export interface StudentReportUpdate {
    featureId: string;
    type: TypeKeys.STUDENT_REPORT_UPDATE;
}

export interface RemoveSubmission {
    type: TypeKeys.REMOVE_SUBMISSION;
    featureId: string;
}

export interface RequestPrintCorrection {
    type: TypeKeys.REQUEST_PRINT_CORRECTION;
    featureId: string;
}

export type ActionTypes = LoadInitialData | StudentReportInfoLoaded
    | PrintStudentReport | ToggleAdminViewReportAsStudent | StudentReportUpdate | ToggleAdminViewRubricMarksAction
    | RequestPrintCorrection;

export const setInitialData = (featureId: string): LoadInitialData => ({
    featureId,
    type: TypeKeys.SET_INITIAL_DATA,
});

export const studentReportInfoLoaded = (featureId: string,
    studentReportInfo: CustomStudentReportInfo): StudentReportInfoLoaded => ({
    featureId,
    studentReportInfo,
    type: TypeKeys.STUDENT_REPORT_INFO_LOADED,
});

export const toggleAdminViewReportAsStudent = (featureId: string): ToggleAdminViewReportAsStudent => ({
    featureId,
    type: TypeKeys.TOGGLE_ADMIN_VIEW_REPORT_AS_STUDENT,
});

export const printStudentReport = (featureId: string): PrintStudentReport => ({
    featureId,
    type: TypeKeys.PRINT_STUDENT_REPORT,
});

export const studentReportUpdate = (featureId: string): StudentReportUpdate => ({
    featureId,
    type: TypeKeys.STUDENT_REPORT_UPDATE,
});

export const removeSubmission = (featureId: string): RemoveSubmission => ({
    type: TypeKeys.REMOVE_SUBMISSION,
    featureId,
});

export const toggleAdminViewRubricMarks = (featureId: string): ToggleAdminViewRubricMarksAction => ({
    type: TypeKeys.TOGGLE_ADMIN_VIEW_RUBRIC_MARKS,
    featureId,
});

export const requestPrintCorrection = (featureId: string) => ({
    type: TypeKeys.REQUEST_PRINT_CORRECTION,
    featureId,
});
